import ModalDialog from "@mui/joy/ModalDialog";
import Modal from "@mui/joy/Modal";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  bank_detail,
  upload_image,
  upload_multiple_image,
} from "../../../../reduxData/user/userAction";
import { useSelector } from "react-redux";
const { REACT_APP_IMAGE_URL } = process.env;

const CustomPaymentModel = ({
  open,
  setOpen,
  userDetails,
  approve,
  rejectRequwest,
  reqAmount,
}) => {
  const [showReject, setShowReject] = useState(false);
  const [rejectMsg, setRejectMsg] = useState("");
  const [proof, setShowProof] = useState("");
  const [bankDetails, setBankDetails] = useState({});
  const token = useSelector((State) => State.auth.accessToken);

  // console.log("user is ", userDetails)
  const [image, setImage] = useState("");
  const handleReject = () => {
    if (!rejectMsg.trim()) {
      toast.error("Reject message is required");
      return;
    }
    setImage("");
    rejectRequwest(rejectMsg);
    setRejectMsg("");
    setShowReject(false);
    setOpen(false);
  };

  const handleApprove = () => {
    approve(image);
    setRejectMsg("");
    setShowReject(false);
    setOpen(false);
    setImage("");
  };

  const handleUploadImage = async (img) => {
    if (!img) return;
    const data = await upload_image(img, token);
    console.log("image is", data?.data?.data);
    setImage(data?.data?.data);
  };

  const getBankDetails = async () => {
    if (!userDetails?.seller_id) {
      return;
    }
    console.log("test 1");
    const res = await bank_detail(userDetails?.seller_id);
    if (res) {
      setBankDetails(res);
    }
  };

  useEffect(() => {
    getBankDetails();
  }, [userDetails]);

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
        // rejectRequwest(rejectMsg);
        setRejectMsg("");
        setShowReject(false);
        setImage("");
      }}
    >
    <ModalDialog
  sx={{
    width: 520,
    maxWidth: "95vw",
    borderRadius: "16px",
    p: 3,
     scrollbarWidth: "none",        // Firefox
    "&::-webkit-scrollbar": {
      display: "none",             // Chrome, Safari
    },
  }}
>
  <div className="d-flex flex-column gap-3">

    {/* HEADER */}
    <div className="d-flex justify-content-between align-items-center">
      <h5 className="mb-0 fw-bold">Withdrawal Request</h5>
      <button
        className="btn btn-sm"
        onClick={() => {
          setOpen(false);
          setRejectMsg("");
          setShowReject(false);
          setImage("");
        }}
      >
        ✕
      </button>
    </div>

    {/* AMOUNT */}
    <div className="p-3 rounded-3 bg-light border">
      <span className="text-muted small">Requested Amount</span>
      <h4 className="fw-bold mb-0 text-success">
        ${userDetails?.wallet_amount}
      </h4>
    </div>

    {/* BANK DETAILS */}
    <div>
      <h6 className="fw-bold mb-2">Bank Details</h6>

      <div className="p-3 border rounded-3 bg-white shadow-sm d-flex flex-column gap-2">

        <div className="d-flex justify-content-between">
          <span className="text-muted">Account Name</span>
          <span className="fw-semibold">{bankDetails?.account_name}</span>
        </div>

        <div className="d-flex justify-content-between">
          <span className="text-muted">Bank</span>
          <span className="fw-semibold">{bankDetails?.bank_name}</span>
        </div>

        <div className="d-flex justify-content-between">
          <span className="text-muted">IBAN</span>
          <span className="fw-semibold">{bankDetails?.iban}</span>
        </div>

        <div className="d-flex justify-content-between">
          <span className="text-muted">SWIFT</span>
          <span className="fw-semibold">{bankDetails?.swift}</span>
        </div>

        <div className="d-flex justify-content-between">
          <span className="text-muted">Account No.</span>
          <span className="fw-semibold">
            {bankDetails?.account_number}
          </span>
        </div>
      </div>

      <div className="mt-2 text-muted small">
        {userDetails?.email}
      </div>
    </div>

    {/* UPLOAD */}
    <div className="p-3 border rounded-3 bg-light d-flex flex-column gap-2">
      <span className="fw-semibold">Upload Payment Proof</span>

      {image ? (
        <div className="position-relative">
          <img
            src={`${REACT_APP_IMAGE_URL}${image}`}
            className="img-fluid rounded-3"
            style={{ maxHeight: 150, objectFit: "cover" }}
          />
          <span
            onClick={() => setImage("")}
            style={{
              position: "absolute",
              top: 8,
              right: 8,
              cursor: "pointer",
              background: "#fff",
              borderRadius: "50%",
              padding: "2px 6px",
            }}
          >
            ✕
          </span>
        </div>
      ) : (
        <label
          htmlFor="proof"
          className="border rounded-3 text-center py-3 cursor-pointer"
          style={{ borderStyle: "dashed" }}
        >
          <div className="text-muted">Click to upload image</div>
        </label>
      )}

      <input
        id="proof"
        type="file"
        className="d-none"
        accept="image/*"
        onChange={(e) => handleUploadImage(e.target.files[0])}
      />
    </div>

    {/* ACTION BUTTONS */}
    <div className="d-flex gap-2 mt-2">
      <button
        onClick={handleApprove}
        disabled={!image}
        className="btn btn-success w-100 fw-bold rounded-pill"
      >
        Approve
      </button>

      <button
        onClick={() => setShowReject(true)}
        className="btn btn-outline-danger w-100 fw-bold rounded-pill"
      >
        Reject
      </button>
    </div>

    {/* REJECT BOX */}
    {showReject && (
      <div className="border rounded-3 p-3 bg-light mt-2">
        <textarea
          value={rejectMsg}
          onChange={(e) => setRejectMsg(e.target.value)}
          placeholder="Write rejection reason..."
          rows="3"
          className="form-control"
        />

        <button
          onClick={handleReject}
          disabled={!rejectMsg.trim()}
          className="btn btn-danger mt-2 w-100 rounded-pill fw-bold"
        >
          Confirm Reject
        </button>
      </div>
    )}
  </div>
</ModalDialog>
    </Modal>
  );
};
export default CustomPaymentModel;
